<div class="p-5 bg-white rounded-2xl mt-3 relative" [style]="iconStyle">
  <div class="absolute -right-[10px] -top-[10px] !border-[10px] w-16 aspect-square rounded-full border-solid border-white grid place-items-center">
    <mat-icon class="!w-6 !h-6 !text-[1.5rem] text-black">{{ icon }}</mat-icon>
  </div>
  <div [style]="iconStyle" class="inline-block py-1 px-5 font-semibold !text-black rounded-lg">
  <ng-container *ngIf="title">
    <div>
      {{ value }}
    </div>
  <div class="mt-3 text-black">{{ title }}</div>
  </ng-container>

  <ng-container *ngIf="title2">
  <div>
      {{ value2 }}
  </div>
  <div class="mt-3 text-black">{{ title2 }}</div>
  </ng-container>

    <ng-container *ngIf="title3">
  <div>

      {{ value3 }}

  </div>
  <div class="mt-3 text-black">{{ title3 }}</div>
    </ng-container>
</div>
</div>
